import type { ReactNode } from 'react';
import type { StorageDashboardCardId, StorageDashboardSummary } from './storageDashboardTypes';
import { StorageAccessCard } from './StorageAccessCard';
import { StorageLatestFilesCard } from './StorageLatestFilesCard';
import { StorageRecentActivityCard } from './StorageRecentActivityCard';

interface RenderStorageDashboardCardOptions {
  openHref: string;
  openLabel: string;
  accessTitle?: string;
  accessSubtitle?: string;
}

export function renderStorageDashboardCard(
  id: StorageDashboardCardId,
  summary: StorageDashboardSummary,
  options: RenderStorageDashboardCardOptions
): ReactNode {
  if (id === 'storageAccess') {
    return (
      <StorageAccessCard
        summary={summary}
        title={options.accessTitle}
        subtitle={options.accessSubtitle}
        openHref={options.openHref}
        openLabel={options.openLabel}
      />
    );
  }
  if (id === 'recentActivity') {
    return <StorageRecentActivityCard summary={summary} />;
  }
  return <StorageLatestFilesCard summary={summary} />;
}
